import React from 'react';
import { Sparkles } from 'lucide-react';

const Header: React.FC = () => {
  return (
    <header className="py-8 px-4 text-center no-print">
      <div className="flex items-center justify-center gap-3 mb-2">
        <Sparkles className="w-8 h-8 text-yellow-400" />
        <h1 className="text-3xl md:text-4xl font-bold tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-amber-600">
          TT Lotto Plus Predictor
        </h1>
      </div>
      <p className="text-slate-400 text-sm md:text-base max-w-lg mx-auto">
        Historical analysis for NLCB Lotto Plus with live result lookup and statistically generated number sets.
      </p>
    </header>
  );
};

export default Header;